import { PlaceholderView } from 'src/components';

export const RecipesPage: React.FC = () => (
  <PlaceholderView title="Przepisy" />
);
